import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert, Typography, Box, Checkbox, FormGroup, FormControlLabel,
} from '@mui/material';
import RoomDimensionsFields from '../RoomDimensionsFields';

const CreateRoomDialog = ({ open, onClose, newRoom, onNewRoomChange, onSubmit, projectRooms, isMobile }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={isMobile}>
    <DialogTitle>{newRoom.type === 'work_area' ? 'Add Work Area' : 'Add Room'}</DialogTitle>
    <DialogContent>
      {newRoom.type === 'work_area' && (
        <Alert severity="info" sx={{ mb: 2, mt: 1 }}>
          A work area groups existing rooms together for organization. Select which rooms below.
        </Alert>
      )}

      <TextField
        autoFocus
        margin="dense"
        label={newRoom.type === 'room' ? 'Room Name' : 'Work Area Name'}
        fullWidth
        variant="outlined"
        value={newRoom.name}
        onChange={(e) => onNewRoomChange({ ...newRoom, name: e.target.value })}
        sx={{ mb: 2, mt: newRoom.type === 'room' ? 1 : 0 }}
        placeholder={newRoom.type === 'room' ? 'e.g., Kitchen, Master Bedroom' : 'e.g., Main Floor Flooring, Upstairs Drywall'}
      />

      {newRoom.type === 'room' && (
        <RoomDimensionsFields
          sx={{ mb: 2 }}
          squareFootage={newRoom.square_footage}
          onSquareFootageChange={(v) => onNewRoomChange({ ...newRoom, square_footage: v })}
          ceilingHeight={newRoom.ceiling_height}
          onCeilingHeightChange={(v) => onNewRoomChange({ ...newRoom, ceiling_height: v })}
        />
      )}

      {newRoom.type === 'work_area' && projectRooms?.filter(r => r.type === 'room').length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>Select Rooms to Include</Typography>
          <Typography variant="caption" color="text.secondary" gutterBottom display="block" sx={{ mb: 1 }}>
            Choose which rooms are part of this work area
          </Typography>
          <FormGroup>
            {projectRooms.filter(r => r.type === 'room').map((room) => (
              <FormControlLabel
                key={room.id}
                control={
                  <Checkbox
                    checked={newRoom.room_ids.includes(room.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onNewRoomChange({ ...newRoom, room_ids: [...newRoom.room_ids, room.id] });
                      } else {
                        onNewRoomChange({ ...newRoom, room_ids: newRoom.room_ids.filter(id => id !== room.id) });
                      }
                    }}
                  />
                }
                label={room.name}
              />
            ))}
          </FormGroup>
        </Box>
      )}

      {newRoom.type === 'work_area' && (
        <TextField
          margin="dense"
          label="Description (Optional)"
          fullWidth
          variant="outlined"
          multiline
          rows={2}
          value={newRoom.description}
          onChange={(e) => onNewRoomChange({ ...newRoom, description: e.target.value })}
          placeholder="Additional details about this work area"
        />
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSubmit} variant="contained" disabled={!newRoom.name.trim()}>
        {newRoom.type === 'work_area' ? 'Create Work Area' : 'Create Room'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CreateRoomDialog;
